import { render, staticRenderFns } from "./DataListThumbView.vue?vue&type=template&id=2c7bc1ca&"
import script from "./DataListThumbView.vue?vue&type=script&lang=js&"
export * from "./DataListThumbView.vue?vue&type=script&lang=js&"
import style0 from "./DataListThumbView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports